import Api from 'api/api';
import { queryKeys } from 'api/queryKeys';

export const userEmail = {
  queryKey: queryKeys.userEmail,
  queryFn: Api.getRegistrationEmail,
};
